import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchGalleryByTitle } from '../helpers/contentfulHelper';
import styles from '../styles/OurWorkPage.module.css';

const categorySections = [
  {
    title: 'Stairs',
    slug: 'stairs',
    intro:
      'Feature staircases and practical everyday stairs, built to suit property style and usage.',
    images: [
      'https://images.unsplash.com/photo-1600585154340-be6161a56a0c',
      'https://images.unsplash.com/photo-1616486029423-aaa4789e8c9a',
      'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c',
    ],
  },
  {
    title: 'Windows',
    slug: 'windows',
    intro:
      'Bespoke timber windows made for performance, longevity and architectural character.',
    images: [
      'https://images.unsplash.com/photo-1513694203232-719a280e022f',
      'https://images.unsplash.com/photo-1600210492486-724fe5c67fb3',
      'https://images.unsplash.com/photo-1505693416388-ac5ce068fe85',
    ],
  },
  {
    title: 'Doors',
    slug: 'doors',
    intro:
      'Internal and external door sets handcrafted with careful detailing and durable finishes.',
    images: [
      'https://images.unsplash.com/photo-1505692952047-1a78307da8f2',
      'https://images.unsplash.com/photo-1493666438817-866a91353ca9',
      'https://images.unsplash.com/photo-1617104551722-3b2d513664ff',
    ],
  },
  {
    title: 'Gates',
    slug: 'gates',
    intro:
      'Driveway, garden and access gates made to measure for security and visual impact.',
    images: [
      'https://images.unsplash.com/photo-1628744448840-55bdb2497bd4',
      'https://images.unsplash.com/photo-1494526585095-c41746248156',
      'https://images.unsplash.com/photo-1505693314120-0d443867891c',
    ],
  },
  {
    title: 'Mouldings',
    slug: 'mouldings',
    intro:
      'Custom timber mouldings produced for restoration and new-build projects, matched to profile and finish.',
    images: [
      'https://images.unsplash.com/photo-1505691938895-1758d7feb511',
      'https://images.unsplash.com/photo-1484154218962-a197022b5858',
      'https://images.unsplash.com/photo-1493666438817-866a91353ca9',
    ],
  },
  {
    title: 'Miscellaneous',
    slug: 'miscellaneous',
    intro:
      'Special commissions, restoration work and one-off joinery projects for unique requirements.',
    images: [
      'https://images.unsplash.com/photo-1519710164239-da123dc03ef4',
      'https://images.unsplash.com/photo-1505691938895-1758d7feb511',
      'https://images.unsplash.com/photo-1484154218962-a197022b5858',
    ],
  },
];

const OurWorkPage = () => {
  const [sections, setSections] = useState(categorySections);

  useEffect(() => {
    const loadGalleryPreviews = async () => {
      const updates = await Promise.all(
        categorySections.map(async (category) => {
          const galleryTitle = `${category.title} Gallery`;
          const entry = await fetchGalleryByTitle(galleryTitle);
          const contentfulImages = entry?.fields?.images || [];

          if (!contentfulImages.length) return category;

          const mappedImages = contentfulImages
            .slice(0, 3)
            .map((img) => img?.fields?.file?.url)
            .filter(Boolean)
            .map((url) => `https:${url}`);

          if (!mappedImages.length) return category;

          return {
            ...category,
            images: mappedImages,
          };
        })
      );

      setSections(updates);
    };

    loadGalleryPreviews();
  }, []);

  return (
    <section className={styles.page}>
      <div className={styles.container}>
        <header className={styles.header}>
          <p className={styles.kicker}>Our Work</p>
          <h1>Gallery</h1>
          <p>
            Explore a selection of our work across key joinery categories. Each
            section below links through to its dedicated page.
          </p>
        </header>

        {sections.map((category) => (
          <section key={category.slug} className={styles.category}>
            <div className={styles.categoryHead}>
              <div>
                <h2>{category.title}</h2>
                <p>{category.intro}</p>
              </div>
              <Link to={`/our-work/${category.slug}`}>View all {category.title}</Link>
            </div>

            <div className={styles.gallery}>
              {category.images.map((src, index) => (
                <img
                  key={`${category.slug}-${index}`}
                  src={src}
                  alt={`${category.title} project ${index + 1}`}
                />
              ))}
            </div>
          </section>
        ))}
      </div>
    </section>
  );
};

export default OurWorkPage;
